<template>
    <div>
        <v-row>
            <v-col cols="12" lg="4">
                <el-table :data="tercio1" stripe>
                    <el-table-column prop="numero_dia" label="Número" width="100" />
                    <el-table-column prop="nombre_dia" label="Día" width="100" />
                    <el-table-column label="Feriado" width="100" align="center">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.es_feriado"></el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </v-col>
            <v-col cols="12" lg="4">
                <el-table :data="tercio2" stripe>
                    <el-table-column prop="numero_dia" label="Número" width="100" />
                    <el-table-column prop="nombre_dia" label="Día" width="100" />
                    <el-table-column label="Feriado" width="100" align="center">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.es_feriado"></el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </v-col>
            <v-col cols="12" lg="4">
                <el-table :data="tercio3" stripe>
                    <el-table-column prop="numero_dia" label="Número" width="100" />
                    <el-table-column prop="nombre_dia" label="Día" width="100" />
                    <el-table-column label="Feriado" width="100" align="center">
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.es_feriado"></el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
    props: ["periodoActual"],
    data() {
        return {
            dialogLoader: false,
            dataPaciente: [],
        };
    },
    watch: {},
    methods: {
        dataInit() {
            this.dialogLoader = true;
            axios
                .get(RUTA_API + "/rrhh_planilla_dias/periodo/?periodo=" + this.periodoActual)
                .then((res) => {
                    this.dataPaciente = res.data;
                })
                .catch((res) => {
                    console.log("Error:", res);
                });
        },
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers;
        },
        tercio1() {
            const total = this.dataPaciente.length;
            const tercio = Math.ceil(total / 3);
            return this.dataPaciente.slice(0, tercio);
        },
        tercio2() {
            const total = this.dataPaciente.length;
            const tercio = Math.ceil(total / 3);
            return this.dataPaciente.slice(tercio, tercio * 2);
        },
        tercio3() {
            const total = this.dataPaciente.length;
            const tercio = Math.ceil(total / 3);
            return this.dataPaciente.slice(tercio * 2, total);
        }
    },
    created() {
        this.dataInit();
    },
    components: {},
};
</script>